var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bloque',{attrs:{"title":_vm.aItems.Pregunta}})
}
var staticRenderFns = []

export { render, staticRenderFns }